import { useEffect, useMemo, useCallback, useRef } from 'react'
import './ee.css'

const useKonamiCode = () => {
  const konamiCode = useMemo(
    () => [
      'ArrowUp',
      'ArrowUp',
      'ArrowDown',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'ArrowLeft',
      'ArrowRight',
      'KeyB',
      'KeyA'
    ],
    []
  )

  const userKeysRef = useRef([]) // Store keys in a ref to prevent re-renders

  const onComplete = useCallback(() => {
    const elements = Array.from(document.querySelectorAll('*'))

    let smallElements = elements.filter(element => element.offsetWidth * element.offsetHeight < 10000)
    const largeElements = elements.filter(element => element.offsetWidth * element.offsetHeight >= 10000).reverse()

    const shuffle = array => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
      }
      return array
    }

    smallElements = shuffle(smallElements)
    smallElements.forEach((row, index) => {
      const delay = index * 0.1
      row.style.animation = `shrinkAndDisappear 2s ease-in-out ${delay}s forwards`
    })
    const baseDelay = smallElements.length * 0.1
    largeElements.forEach((row, index) => {
      const delay = baseDelay + index * 0.2
      row.style.animation = `shrinkAndDisappear 2s ease-in-out ${delay}s forwards`
    })
  }, [])

  useEffect(() => {
    const handleKeyDown = e => {
      userKeysRef.current = [...userKeysRef.current, e.code].slice(-konamiCode.length) // Update ref, NOT state

      if (JSON.stringify(userKeysRef.current) === JSON.stringify(konamiCode)) {
        onComplete()
        userKeysRef.current = [] // Reset sequence after successful match
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [konamiCode, onComplete])

  return null // This hook does not return anything
}

export default useKonamiCode
